export class MouseWheelEvent {
	protected bound: boolean = false;
	protected delta: PIXI.Point;
	protected obj: any;
	protected preventDefault: boolean;

	protected onMouseScroll: EventListenerOrEventListenerObject;

	public scrollCallback: Function;

	/**
	 * Mouse scroll event class. Add to object - setup start, stop and callback events. Outputs delta position.
	 * TODO: Check regular and standardized 'wheel' event.
	 * @param {*} obj
	 * @param {Function} scrollCallback
	 * @memberof MouseScrollEvent
	 */
	constructor(obj: any, scrollCallback: Function) {
		this.delta = new PIXI.Point();
		this.scrollCallback = scrollCallback;
		this.obj = obj;
		this.onMouseScroll = this._onMouseScroll.bind(this) as EventListenerOrEventListenerObject;
		// To keep the correct context when the function is removed from the eventlistener.
	}

	protected _onMouseScroll(event: any): void {
		if (this.preventDefault) {
			event.preventDefault();
		}

		if (typeof event.deltaX !== 'undefined') {
			this.delta.set(event.deltaX, event.deltaY);
		} else {
			// Firefox
			this.delta.set(event.axis === 1 ? event.detail * 60 : 0, event.axis === 2 ? event.detail * 60 : 0);
		}

		this.scrollCallback(this.delta);
	}

	protected onHover(event: any): void {
		if (!this.bound) {
			document.addEventListener('mousewheel', this.onMouseScroll);
			document.addEventListener('DOMMouseScroll', this.onMouseScroll);
			this.bound = true;
		}
	}

	protected onMouseOut(event: any): void {
		if (this.bound) {
			document.removeEventListener('mousewheel', this.onMouseScroll);
			document.removeEventListener('DOMMouseScroll', this.onMouseScroll);
			this.bound = false;
		}
	}

	public stopEvent(): void {
		if (this.bound) {
			document.removeEventListener('mousewheel', this.onMouseScroll);
			document.removeEventListener('DOMMouseScroll', this.onMouseScroll);
			this.bound = false;
		}

		this.obj.removeListener('mouseover', this.onHover);
		this.obj.removeListener('mouseout', this.onMouseOut);
	}

	public startEvent(hovering: boolean = false): void {
		this.obj.on('mouseover', this.onHover.bind(this));
		this.obj.on('mouseout', this.onMouseOut.bind(this));

		if (hovering) {
			this.onHover(null);
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/interaction/MouseWheelEvent.ts